import Api from '@/services/Api'

export default {
 getVaccines () {
   return Api().get("/vaccines");
},
  updateVaccine (params) {
    return Api().put("/vaccines",params);
  },
  addVaccine (params) {
    return Api().post("/vaccines",params);
  },
  getVaccine (params) {
    return Api().get("/vaccines/"+params);
  },
  deleteVaccine(params) {
    return Api().delete("/vaccines/"+params);
  },
  getAvailableVaccinesPerPatientRouteSheet(params) {
    return Api().get("/available-vaccines/"+params);
  },
  findAllOrderByName() {
    return Api().get("/vaccines-order-by-name");
  },
  findByDosisAndGroup(params) {
    return Api().get("find-by-dosis-and-group/"+params);
  }  
}



// WEBPACK FOOTER //
// ./src/services/VaccineService.js